import React, { useContext } from 'react';
import PersonalIdentificationForm from './PersonalIdentificationForm';
import useCliDataContext from '../../hooks/useCliDataContext';
import { AccessibleForm, Loader, StepperContext } from '@digitools/honest-react';
import useAuthentication from 'src/hooks/useAuthentication';
import { CheckForPrePropData } from '../../api/CliApiCalls';
import useCliCustomerConfigContext from '../../hooks/useCliContext';
import { Experience } from 'src/types/Experience';
import useExperience from 'src/hooks/useExperience';
import useTealium from 'src/hooks/useTealium';
import { TEALIUM_EVENT } from 'src/constants/tealiumConstants';
import { Environment } from 'src/types/Environment';
import { getEnvironment } from 'src/utils/envUtils';
const IdentityVerification = () => {
    const { authHeader } = useAuthentication();
    const { claimantData, setClaimantData, setIsPrePopLoading, isPrePopLoading, setHasEligibilityEmpState, } = useCliDataContext();
    const { hasPrePopEnabled } = useCliCustomerConfigContext();
    const { experience } = useExperience();
    const { trackEvent } = useTealium();
    const { user } = useAuthentication();
    const stepper = useContext(StepperContext);
    const trackContinue = () => trackEvent({
        event_action: TEALIUM_EVENT.EVENT_ACTION.SELF_SERVICE,
        event_name: 'continue',
        event_type: TEALIUM_EVENT.EVENT_TYPE.CLAIM_LEAVE_INTAKE,
        event_version: 'getting started',
        event_status: TEALIUM_EVENT.EVENT_STATUS.START,
    });
    const onSubmit = async (values) => {
        setIsPrePopLoading(true);
        const payload = {
            // @ts-ignore
            lastName: values?.claimantData?.lastName ? values.claimantData.lastName.trim() : user?.lastName || null,
            // @ts-ignore
            empID: values?.claimantData?.empID ? values.claimantData.empID.trim() : null,
            // @ts-ignore
            ssn: values?.claimantData?.ssn ? values.claimantData.ssn.trim() : null,
        };
        const isLocalOrNonProd = getEnvironment() === Environment.DEV || getEnvironment() === Environment.NON_PROD;
        if (isLocalOrNonProd && user?.isLfgUser && !user?.isIdentityVerified) {
            trackContinue();
            setClaimantData({ ...payload });
            setIsPrePopLoading(false);
            stepper.next();
            return;
        }
        const { response } = await CheckForPrePropData(payload, authHeader());
        if (response.code === 200) {
            if (hasPrePopEnabled) {
                //FIXME: GENDER HACK -- push this into the back-end
                const hackedResponse = response;
                if (hackedResponse?.data?.gender && hackedResponse?.data?.gender !== 'M' && hackedResponse?.data?.gender !== 'F') {
                    hackedResponse.data.gender = undefined;
                }
                if (hackedResponse?.data?.selectedEmpStateID?.length !== 2) {
                    hackedResponse.data.selectedEmpStateID = undefined;
                }
                if (experience === Experience.EMPLOYEE) {
                    setClaimantData({ ...hackedResponse.data, ...claimantData, ...payload, });
                }
                else {
                    setClaimantData({ ...claimantData, ...hackedResponse.data, ...payload });
                }
            }
            else {
                setClaimantData({ ...payload });
            }
            trackContinue();
            setIsPrePopLoading(false);
            setHasEligibilityEmpState(true);
            if (response?.data?.selectedEmpStateID === "  ") {
                setHasEligibilityEmpState(false);
            }
            else {
                setHasEligibilityEmpState(true);
            }
            stepper.next();
        }
        else if (response.code === 404 || response.code === 429) {
            // 429: the employee is rate limited on prepop, so continue as if nothing was found
            setClaimantData({ ...claimantData, ...payload });
            trackContinue();
            setIsPrePopLoading(false);
            stepper.next();
            window.scrollTo(0, 0);
        }
        else {
            setIsPrePopLoading(false);
        }
    };
    return (<Loader viewportCentered={false} id='cli-eligibility-spinner' isShown={isPrePopLoading} data-testid={'cli-eligibility-spinner'}>
            <AccessibleForm onSubmit={onSubmit} data-testid='identity-verification-form'>
                <PersonalIdentificationForm />
            </AccessibleForm>
        </Loader>);
};
export default IdentityVerification;
